import React from 'react'
import PropTypes from 'prop-types'
import { useFormattingContext } from '../../../FormattingProvider/FormattingContext'
import {
  useTaskRowStyles,
  TaskRow,
  getVisibleItems,
  getCompletedValue,
  getItemKey
} from './shared'

function TasksList ({ data, displayConfig, isAdvisor }) {
  const classes = useTaskRowStyles()
  const { formatter } = useFormattingContext()
  const visibleItems = getVisibleItems(data, displayConfig, isAdvisor)
  if (!visibleItems.length) return null

  const detailFields = displayConfig?.detailFields
  const completedValue = getCompletedValue(displayConfig)

  return (
    <ul className={classes.list}>
      {visibleItems.map((item, idx) => (
        <TaskRow
          key={getItemKey(item, displayConfig, idx)}
          item={item}
          displayConfig={displayConfig}
          detailFields={detailFields}
          formatter={formatter}
          completedValue={completedValue}
          classes={classes}
        />
      ))}
    </ul>
  )
}

TasksList.propTypes = {
  data: PropTypes.object,
  displayConfig: PropTypes.object,
  isAdvisor: PropTypes.bool
}

export default TasksList
